import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function enrolleeReducer(state = initialState.enrollee, action) {
  switch (action.type) {
    case types.ENROLLEE_LOGIN_SUCCESS:
      return state;
    case types.ENROLLEE_LOGOUT_SUCCESS:
      return state;
    case types.ENROLLEE_UPDATE_SUCCESS:
      return action.enrollee;
    case types.CLIENT_UPDATE_SUCCESS:
      return action.enrollee;
    default:
      return state;
  }
}
